import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/HeaderFooter/Footer';
import '../styles/ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleConfirm = () => {
    // Reset the error message
    setError('');

    if (!email) {
      // Display an error if the email field is empty
      setError('Please enter your email address.');
      return;
    }

    // If the email is not empty, navigate to the reset confirmation page
    navigate('/resetemailconfirmation');
  };

  return (
    <div className="resetpassword">
      <div className="content-wrapper">
        <div className="logo">
          <img src="/images/logo.png" alt="Caliber Logo" />
        </div>

        <div className="resetpassword-card">
          <h1 className="reset">Reset Password</h1>
          <p className="subtitle">
            Enter the email associated with your account and we will send the instruction to reset the password.
          </p>

          <div className="input-row">
            <div className="input-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="text"
                id="email"
                placeholder="Enter Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          {error && <p className="error-message">{error}</p>}

          <div className="button-row">
            <button className="reset-btn cancel-btn" onClick={() => navigate('/login')}>
              Cancel
            </button>
            <button className="reset-btn confirm-btn" onClick={handleConfirm}>
              Confirm
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ForgotPassword;
